import { render, staticRenderFns } from "./ModuleSwap.vue?vue&type=template&id=506644e6&scoped=true&"
import script from "./ModuleSwap.vue?vue&type=script&lang=js&"
export * from "./ModuleSwap.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSwap.vue?vue&type=style&index=0&id=506644e6&lang=scss&scoped=true&"
import style1 from "./ModuleSwap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506644e6",
  null
  
)

export default component.exports